// src/pages/VisitorsPage.js
import React, { useState, useEffect } from 'react';
import { visitorAPI } from '../api/api';
import { Modal, FormRow, ModalActions } from './ClassesPage';
import toast from 'react-hot-toast';
import './CommonPage.css';

const TYPES = { task_force:'ಟಾಸ್ಕ್ ಫೋರ್ಸ್', district_officer:'ಜಿಲ್ಲಾ ಅಧಿಕಾರಿ', taluk_officer:'ತಾಲೂಕು ಅಧಿಕಾರಿ', sdmc_member:'ಎಸ್.ಡಿ.ಎಂ.ಸಿ. ಸದಸ್ಯ', other:'ಇತರ' };

export default function VisitorsPage() {
  const [visitors, setVisitors] = useState([]);
  const [showAdd, setShowAdd]   = useState(false);
  const [loading, setLoading]   = useState(false);
  const [expandedId, setExpandedId] = useState(null);
  const [form, setForm] = useState({ visit_date: new Date().toISOString().slice(0,10), visitor_type:'taluk_officer', visitor_name:'', designation:'', organization:'', purpose:'', observations:'', recommendations:'' });

  const load = () => visitorAPI.list().then(r => setVisitors(r.data.data)).catch(()=>{});
  useEffect(() => { load(); }, []); // wrapped to avoid returning Promise

  const save = async () => {
    if (!form.visitor_name || !form.visit_date) { toast.error('ಹೆಸರು ಮತ್ತು ದಿನಾಂಕ ಅಗತ್ಯ'); return; }
    setLoading(true);
    try {
      await visitorAPI.add(form);
      toast.success('ಸಂದರ್ಶನ ದಾಖಲಿಸಲಾಗಿದೆ ✅');
      setShowAdd(false); load();
    } catch(e) { toast.error(e.response?.data?.message||'ತಪ್ಪಾಗಿದೆ'); }
    finally { setLoading(false); }
  };

  return (
    <div className="common-page">
      <div className="page-header">
        <h1 className="page-title">👥 ಸಂದರ್ಶನದ ವರದಿ</h1>
        <p className="page-desc">ಅಧಿಕಾರಿಗಳ ಶಾಲಾ ಭೇಟಿ ದಾಖಲು</p>
      </div>
      <div className="action-bar">
        <button className="act-btn act-green" onClick={()=>setShowAdd(true)}>+ ಭೇಟಿ ದಾಖಲಿಸಿ</button>
      </div>

      <div className="visitor-list">
        {visitors.length === 0 && (
          <div style={{textAlign:'center',padding:'3rem',color:'rgba(255,255,255,0.3)',fontFamily:'Noto Sans Kannada'}}>ಇನ್ನೂ ಭೇಟಿ ದಾಖಲಿಸಿಲ್ಲ</div>
        )}
        {visitors.map(v => (
          <div key={v.id} className="visitor-card">
            <div className="visitor-date">
              {new Date(v.visit_date).toLocaleDateString('kn-IN',{day:'numeric',month:'short',year:'numeric'})}
            </div>
            <div className="visitor-info">
              <div className="visitor-name">{v.visitor_name}</div>
              <div className="visitor-desig">{v.designation} {v.organization && `· ${v.organization}`}</div>
              {v.purpose && <div style={{fontFamily:'Noto Sans Kannada',fontSize:'0.75rem',color:'rgba(255,255,255,0.5)',marginTop:'0.3rem'}}>ಉದ್ದೇಶ: {v.purpose}</div>}
              {v.observations && <div style={{fontFamily:'Noto Sans Kannada',fontSize:'0.75rem',color:'rgba(255,255,255,0.4)',marginTop:'0.2rem'}}>ಗಮನಿಸಿದ್ದು: {v.observations}</div>}
            </div>
            <span className="visitor-type-badge">{TYPES[v.visitor_type]||v.visitor_type}</span>
          </div>
        ))}
      </div>

      {showAdd && (
        <Modal title="ಭೇಟಿ ದಾಖಲಿಸಿ" onClose={()=>setShowAdd(false)}>
          <FormRow label="ಭೇಟಿ ದಿನಾಂಕ">
            <input className="modal-input" type="date" value={form.visit_date} onChange={e=>setForm(p=>({...p,visit_date:e.target.value}))} />
          </FormRow>
          <FormRow label="ಅಧಿಕಾರಿ ವಿಧ">
            <select className="modal-input" value={form.visitor_type} onChange={e=>setForm(p=>({...p,visitor_type:e.target.value}))}>
              {Object.entries(TYPES).map(([k,v])=><option key={k} value={k}>{v}</option>)}
            </select>
          </FormRow>
          <FormRow label="ಹೆಸರು *">
            <input className="modal-input" placeholder="ಶ್ರೀ / ಶ್ರೀಮತಿ ..." value={form.visitor_name} onChange={e=>setForm(p=>({...p,visitor_name:e.target.value}))} />
          </FormRow>
          <FormRow label="ಹುದ್ದೆ">
            <input className="modal-input" placeholder="ಶಿಕ್ಷಣ ಅಧಿಕಾರಿ" value={form.designation} onChange={e=>setForm(p=>({...p,designation:e.target.value}))} />
          </FormRow>
          <FormRow label="ಇಲಾಖೆ / ಸಂಸ್ಥೆ">
            <input className="modal-input" placeholder="ತಾಲೂಕು ಪಂಚಾಯತ್" value={form.organization} onChange={e=>setForm(p=>({...p,organization:e.target.value}))} />
          </FormRow>
          <FormRow label="ಭೇಟಿಯ ಉದ್ದೇಶ">
            <input className="modal-input" placeholder="MDM ತಪಾಸಣೆ" value={form.purpose} onChange={e=>setForm(p=>({...p,purpose:e.target.value}))} />
          </FormRow>
          <FormRow label="ಗಮನಿಸಿದ ವಿಷಯಗಳು">
            <textarea className="modal-input" rows={2} placeholder="ಊಟ ಶುಚಿಯಾಗಿದೆ..." value={form.observations} onChange={e=>setForm(p=>({...p,observations:e.target.value}))} style={{resize:'none'}} />
          </FormRow>
          <FormRow label="ಶಿಫಾರಸುಗಳು">
            <textarea className="modal-input" rows={2} placeholder="..." value={form.recommendations} onChange={e=>setForm(p=>({...p,recommendations:e.target.value}))} style={{resize:'none'}} />
          </FormRow>
          <ModalActions loading={loading} onSave={save} onCancel={()=>setShowAdd(false)} />
        </Modal>
      )}
    </div>
  );
}